var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.partnerCode==='ultimate_tz' || _vm.partnerCode==='two_tz')?_c('UltimateTz'):_c('Default')
}
var staticRenderFns = []

export { render, staticRenderFns }